<template>
    <div class="chart-container">
      <div>
        <h2>{{ title }}</h2>
        <h3>{{ label }}</h3>
        <h5>{{ totalNumber }}</h5>
      </div>
      <div class="chart" :style="chartStyle"></div>
      <div class="legend">
        <div v-for="(percentage, index) in percentages" :key="index" class="legend-item">
          <span class="color-box" :style="{ backgroundColor: computedColors[index] }"></span>
          {{ sectorNames[index] }}: {{ percentage }}%
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  props: {
    percentages: {
      type: Array,
      required: true
    },
    colors: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: null
    },
    totalNumber: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    sectorNames: {
      type: Array,
      required: true
    }
  },
  computed: {
    total () {
      return this.percentages.reduce((acc, val) => acc + val, 0)
    },
    computedColors () {
      return this.colors.length > 0
        ? this.colors
        : this.percentages.map((_, index) => `hsl(${(index * 360) / this.percentages.length}, 100%, 50%)`)
    },
    chartStyle () {
      const slices = []
      let cumulativeAngle = 0

      this.percentages.forEach((percentage, index) => {
        const angle = (percentage / this.total) * 360
        slices.push(`${this.computedColors[index]} ${cumulativeAngle}deg ${cumulativeAngle + angle}deg`)
        cumulativeAngle += angle
      })

      return {
        background: `conic-gradient(${slices.join(', ')})`
      }
    }
  }
}
</script>

  <style scoped>
  .chart-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .chart {
    width: 300px;
    height: 300px;
    border-radius: 50%;
    margin-bottom: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .legend {
    margin-top: 10px;
  }

  .legend-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }

  .color-box {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  @media (max-width: 576px) {
    .chart {
    width: 250px;
    height: 250px;}

     h3 {
      font-size: 1.2rem;
    }
   }
  </style>



// WEBPACK FOOTER //
// src/views/private/atendimento/indice_atendimento/components/DonutChart.vue